import React, { useState } from 'react';
import { postContact } from '../../provider/ContactUs';
import { isTruthy } from '../../utils/helpers';

const ContactForm = ({t={}}) => {
    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        email: '',
        subject: '',
        comment: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};
        if (!form.firstName.trim()) newErrors.firstName = 'firstNameRequired';
        if (!form.lastName.trim()) newErrors.lastName = 'lastNameRequired';
        if (!form.email.trim()) newErrors.email = 'emailRequired';
        else if (!/\S+@\S+\.\S+/.test(form.email)) newErrors.email = 'emailisInvalid';
        if (!form.subject.trim()) newErrors.subject = 'subject';
        if (!form.comment.trim()) newErrors.comment = 'commentRequired';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setIsLoading(true);
        setMessage('');
        try {
            const response = await postContact(form);
            const { status, result } = response;
            setIsLoading(false);
            setMessage(result);
            if (isTruthy(status)) {
                setIsSuccess(true);
                setForm({
                    firstName: '',
                    lastName: '',
                    email: '',
                    subject: '',
                    comment: ''
                });
                return;
            }
            setIsSuccess(false);
        } catch (err) {
            console.error(err);
        }
    };
    
    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {message && (
                <div
                    className={`rounded-md px-4 py-3 text-sm font-medium ${
                        isTruthy(isSuccess)
                            ? 'bg-green-100 text-green-800 border border-green-300'
                            : 'bg-red-100 text-red-800 border border-red-300'
                    }`}
                    role="alert"
                >
                    {message}
                </div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <input
                        type="text"
                        name="firstName"
                        placeholder={t.enterFirstName}
                        value={form.firstName}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md"
                    />
                    {errors.firstName && <p className="text-red-500 text-sm mt-1">{t[errors.firstName]}</p>}
                </div>
                <div>
                    <input
                        type="text"
                        name="lastName"
                        placeholder={t.enterLastName}
                        value={form.lastName}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md"
                    />
                    {errors.lastName && <p className="text-red-500 text-sm mt-1">{t[errors.lastName]}</p>}
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <input
                        type="email"
                        name="email"
                        placeholder={t.enterEmail}
                        value={form.email}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md"
                    />
                    {errors.email && <p className="text-red-500 text-sm mt-1">{t[errors.email]}</p>}
                </div>
                <div>
                    <input
                        type="text"
                        name="subject"
                        placeholder={t.enterSubject}
                        value={form.subject}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md"
                    />
                    {errors.subject && <p className="text-red-500 text-sm mt-1">{t[errors.subject]}</p>}
                </div>
            </div>

            <div>
                <textarea
                    name="comment"
                    placeholder={t.enterComments}
                    rows="5"
                    value={form.comment}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border rounded-md"
                ></textarea>
                {errors.comment && <p className="text-red-500 text-sm mt-1">{t[errors.comment]}</p>}
            </div>
            {isLoading ? 
                <div className="h-6 w-6 border-4 border-[#d3752b] border-t-transparent rounded-full animate-spin" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
                :
                <button
                    type="submit"
                    className="border py-2 px-4 rounded-md transition duration-300"
                    style={{
                        borderColor: 'rgb(211, 117, 43)',
                        color: 'rgb(211, 117, 43)',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgb(211, 117, 43)';
                        e.currentTarget.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = 'rgb(211, 117, 43)';
                    }}
                >
                    {t.button}
                </button>
            }
        </form>
    );
};

export default ContactForm;
